import React, { useEffect, useState } from "react";
import Sidebar from "../../../component/home/sidebar";
import PlanUsage from "./PlanUsage";
import { useDispatch, useSelector } from "react-redux";
import { redirect } from "react-router-dom";
import { customerPortal } from "../../../redux/actions/user";

export default function BillingDetails() {

  const dispatch = useDispatch();
  const { company } = useSelector(state => state.auth);
  const [url, setUrl] = useState(null);

  useEffect(() => {
    const payload = {
      customer_id: company.stripe_customer_id,
      // customer_id: "cus_OoK7vAqTazUfH0",
      return_url: window.location.href
    }
    dispatch(customerPortal(payload, (data) => {
      if(data.status){
        setUrl(data.data.url)
      }
    }))
  }, []);

  const [openTab, setOpenTab] = useState(1);
  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <div className="flex flex-col md:flex-row" style={{ height: "calc(100vh - 110px)"}}>
        <Sidebar />
        <div className="flex-auto p-5 bg-white max-h-full w-full md:w-2/3">
          <div className="w-full mb-4 flex flex-row justify-between items-center">
            <h4 className="text-xl font-bold leading-8">
              Billing & Plan Details
            </h4>
            {
              url && (
                <a href={url} target="_self" className="btn-xs h-8 text-[#1E293B] text-sm leading-5 border border-slate-200 hover:border-slate-300 px-4">
                  Subscription Management
                </a>
              )
            }
          </div>
          <div className="-mt-1">
            <ul
              className="relative text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar border-b"
              id="tabs-tabJustify"
              role="tablist"
            >
              <li className="flex-grow sm:flex-grow-0 text-left">
                <a
                  href="#tabAdded"
                  className={
                    "w-full block font-medium leading-5 whitespace-nowrap text-xs sm:text-[13px] border-x-0 border-t-0 border-b-2 py-2 my-3" +
                    (openTab === 1
                      ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
                      : null)
                  }
                  id="tab-added"
                  data-toggle="tab"
                  role="tablist"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTab(1);
                  }}
                >
                  Plan Usage
                </a>
              </li>
            </ul>
          </div>
          <PlanUsage openTab={openTab} />
        </div>
      </div>
    </div>
  );
}
BillingDetails.auth = { path: "/billingdetails", role: ["super-admin"] };
